import React from "react";
import { JobDescriptionProps } from "./components/MyJobs";
import DeleteTeamsJobDescription from "./description/DeleteTeamsJobDescription";
import JobMapping from "./job-mappings";

const JobDescription: React.FC<JobDescriptionProps> = ({
  job,
}): JSX.Element => {
  if (job.name === "DELETE_TEAMS" && job.summary) {
    return <DeleteTeamsJobDescription job={job} />;
  }
  return <>-</>;
};

export default JobDescription;
